export default {
  markers: state => state.markers, // array
  selected: state => state.selected, // object

  showLabels: state => state.showLabels, // boolean
  size: state => state.size, // number

  isDeletingOutsideBorder: state => state.isDeletingOutsideBorder // boolean
}
